/**
 * Additional Vocabulary - Round 1
 * 额外词汇 - 第一轮（填补缺口）
 * Target: +186 words to reach 1600 total
 */

import { VocabularyWord } from './vocabulary';

export const additionalVocabularyRound1: VocabularyWord[] = [
  // ==================== 小学3-4年级补充（60词）====================

  // 动物类补充（15词）
  {
    id: 'elem-add-animal-1',
    word: 'mouse',
    phoneticUS: '/maʊs/',
    phoneticUK: '/maʊs/',
    meaning: '老鼠',
    example: 'The mouse is small and cute.',
    exampleTranslation: '这只老鼠又小又可爱。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐭'
  },
  {
    id: 'elem-add-animal-2',
    word: 'wolf',
    phoneticUS: '/wʊlf/',
    phoneticUK: '/wʊlf/',
    meaning: '狼',
    example: 'The wolf lives in the forest.',
    exampleTranslation: '狼生活在森林里。',
    category: 'animals',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🐺'
  },
  {
    id: 'elem-add-animal-3',
    word: 'fox',
    phoneticUS: '/fɑːks/',
    phoneticUK: '/fɒks/',
    meaning: '狐狸',
    example: 'The fox is very clever.',
    exampleTranslation: '狐狸非常聪明。',
    category: 'animals',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🦊'
  },
  {
    id: 'elem-add-animal-4',
    word: 'bear',
    phoneticUS: '/ber/',
    phoneticUK: '/beə/',
    meaning: '熊',
    example: 'The bear loves honey.',
    exampleTranslation: '熊喜欢蜂蜜。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐻'
  },
  {
    id: 'elem-add-animal-5',
    word: 'deer',
    phoneticUS: '/dɪr/',
    phoneticUK: '/dɪə/',
    meaning: '鹿',
    example: 'The deer runs fast.',
    exampleTranslation: '鹿跑得很快。',
    category: 'animals',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🦌'
  },
  {
    id: 'elem-add-animal-6',
    word: 'rabbit',
    phoneticUS: '/ˈræbɪt/',
    phoneticUK: '/ˈræbɪt/',
    meaning: '兔子',
    example: 'The rabbit has long ears.',
    exampleTranslation: '兔子有长长的耳朵。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐰'
  },
  {
    id: 'elem-add-animal-7',
    word: 'turtle',
    phoneticUS: '/ˈtɜːrtl/',
    phoneticUK: '/ˈtɜːtl/',
    meaning: '海龟',
    example: 'The turtle moves slowly.',
    exampleTranslation: '海龟移动得很慢。',
    category: 'animals',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🐢'
  },
  {
    id: 'elem-add-animal-8',
    word: 'frog',
    phoneticUS: '/frɔːɡ/',
    phoneticUK: '/frɒɡ/',
    meaning: '青蛙',
    example: 'The frog can jump high.',
    exampleTranslation: '青蛙能跳得很高。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐸'
  },
  {
    id: 'elem-add-animal-9',
    word: 'duck',
    phoneticUS: '/dʌk/',
    phoneticUK: '/dʌk/',
    meaning: '鸭子',
    example: 'The duck swims in the pond.',
    exampleTranslation: '鸭子在池塘里游泳。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🦆'
  },
  {
    id: 'elem-add-animal-10',
    word: 'goose',
    phoneticUS: '/ɡuːs/',
    phoneticUK: '/ɡuːs/',
    meaning: '鹅',
    example: 'The goose is white and big.',
    exampleTranslation: '这只鹅又白又大。',
    category: 'animals',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🦢'
  },
  {
    id: 'elem-add-animal-11',
    word: 'hen',
    phoneticUS: '/hen/',
    phoneticUK: '/hen/',
    meaning: '母鸡',
    example: 'The hen lays eggs.',
    exampleTranslation: '母鸡下蛋。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐔'
  },
  {
    id: 'elem-add-animal-12',
    word: 'rooster',
    phoneticUS: '/ˈruːstər/',
    phoneticUK: '/ˈruːstə/',
    meaning: '公鸡',
    example: 'The rooster crows in the morning.',
    exampleTranslation: '公鸡在早上打鸣。',
    category: 'animals',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🐓'
  },
  {
    id: 'elem-add-animal-13',
    word: 'pig',
    phoneticUS: '/pɪɡ/',
    phoneticUK: '/pɪɡ/',
    meaning: '猪',
    example: 'The pig is pink and fat.',
    exampleTranslation: '猪是粉红色的，很胖。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐷'
  },
  {
    id: 'elem-add-animal-14',
    word: 'sheep',
    phoneticUS: '/ʃiːp/',
    phoneticUK: '/ʃiːp/',
    meaning: '绵羊',
    example: 'The sheep has soft wool.',
    exampleTranslation: '绵羊有柔软的羊毛。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐑'
  },
  {
    id: 'elem-add-animal-15',
    word: 'horse',
    phoneticUS: '/hɔːrs/',
    phoneticUK: '/hɔːs/',
    meaning: '马',
    example: 'The horse runs very fast.',
    exampleTranslation: '马跑得非常快。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐴'
  },

  // 食物类补充（15词）
  {
    id: 'elem-add-food-1',
    word: 'candy',
    phoneticUS: '/ˈkændi/',
    phoneticUK: '/ˈkændi/',
    meaning: '糖果',
    example: 'I like sweet candy.',
    exampleTranslation: '我喜欢甜糖果。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍬'
  },
  {
    id: 'elem-add-food-2',
    word: 'cookie',
    phoneticUS: '/ˈkʊki/',
    phoneticUK: '/ˈkʊki/',
    meaning: '饼干',
    example: 'Mom baked cookies for us.',
    exampleTranslation: '妈妈为我们烤了饼干。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍪'
  },
  {
    id: 'elem-add-food-3',
    word: 'cake',
    phoneticUS: '/keɪk/',
    phoneticUK: '/keɪk/',
    meaning: '蛋糕',
    example: 'We have a birthday cake.',
    exampleTranslation: '我们有一个生日蛋糕。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🎂'
  },
  {
    id: 'elem-add-food-4',
    word: 'ice cream',
    phoneticUS: '/aɪs kriːm/',
    phoneticUK: '/aɪs kriːm/',
    meaning: '冰淇淋',
    example: 'I eat ice cream in summer.',
    exampleTranslation: '夏天我吃冰淇淋。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍨'
  },
  {
    id: 'elem-add-food-5',
    word: 'chocolate',
    phoneticUS: '/ˈtʃɑːklət/',
    phoneticUK: '/ˈtʃɒklət/',
    meaning: '巧克力',
    example: 'Chocolate is my favorite.',
    exampleTranslation: '巧克力是我的最爱。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🍫'
  },
  {
    id: 'elem-add-food-6',
    word: 'hamburger',
    phoneticUS: '/ˈhæmbɜːrɡər/',
    phoneticUK: '/ˈhæmbɜːɡə/',
    meaning: '汉堡包',
    example: 'I like to eat hamburgers.',
    exampleTranslation: '我喜欢吃汉堡包。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🍔'
  },
  {
    id: 'elem-add-food-7',
    word: 'sandwich',
    phoneticUS: '/ˈsænwɪtʃ/',
    phoneticUK: '/ˈsænwɪdʒ/',
    meaning: '三明治',
    example: 'I made a sandwich for lunch.',
    exampleTranslation: '我做了一个三明治当午餐。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥪'
  },
  {
    id: 'elem-add-food-8',
    word: 'pizza',
    phoneticUS: '/ˈpiːtsə/',
    phoneticUK: '/ˈpiːtsə/',
    meaning: '披萨',
    example: 'Pizza is delicious.',
    exampleTranslation: '披萨很好吃。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍕'
  },
  {
    id: 'elem-add-food-9',
    word: 'hot dog',
    phoneticUS: '/hɑːt dɔːɡ/',
    phoneticUK: '/hɒt dɒɡ/',
    meaning: '热狗',
    example: 'Hot dogs are popular food.',
    exampleTranslation: '热狗是很受欢迎的食物。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🌭'
  },
  {
    id: 'elem-add-food-10',
    word: 'popcorn',
    phoneticUS: '/ˈpɑːpkɔːrn/',
    phoneticUK: '/ˈpɒpkɔːn/',
    meaning: '爆米花',
    example: 'We eat popcorn at the movies.',
    exampleTranslation: '我们在电影院吃爆米花。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🍿'
  },
  {
    id: 'elem-add-food-11',
    word: 'salad',
    phoneticUS: '/ˈsæləd/',
    phoneticUK: '/ˈsæləd/',
    meaning: '沙拉',
    example: 'Vegetable salad is healthy.',
    exampleTranslation: '蔬菜沙拉很健康。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥗'
  },
  {
    id: 'elem-add-food-12',
    word: 'soup',
    phoneticUS: '/suːp/',
    phoneticUK: '/suːp/',
    meaning: '汤',
    example: 'Chicken soup is tasty.',
    exampleTranslation: '鸡汤很美味。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍲'
  },
  {
    id: 'elem-add-food-13',
    word: 'noodle',
    phoneticUS: '/ˈnuːdl/',
    phoneticUK: '/ˈnuːdl/',
    meaning: '面条',
    example: 'I like noodles for dinner.',
    exampleTranslation: '晚餐我喜欢吃面条。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍜'
  },
  {
    id: 'elem-add-food-14',
    word: 'dumpling',
    phoneticUS: '/ˈdʌmplɪŋ/',
    phoneticUK: '/ˈdʌmplɪŋ/',
    meaning: '饺子',
    example: 'We eat dumplings at Chinese New Year.',
    exampleTranslation: '我们在春节吃饺子。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥟'
  },
  {
    id: 'elem-add-food-15',
    word: 'pancake',
    phoneticUS: '/ˈpænkeɪk/',
    phoneticUK: '/ˈpænkeɪk/',
    meaning: '薄煎饼',
    example: 'Pancakes are good for breakfast.',
    exampleTranslation: '薄煎饼适合当早餐。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥞'
  },

  // 学习用品补充（15词）
  {
    id: 'elem-add-school-1',
    word: 'eraser',
    phoneticUS: '/ɪˈreɪsər/',
    phoneticUK: '/ɪˈreɪzə/',
    meaning: '橡皮',
    example: 'I use an eraser to correct mistakes.',
    exampleTranslation: '我用橡皮擦改正错误。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧽'
  },
  {
    id: 'elem-add-school-2',
    word: 'sharpener',
    phoneticUS: '/ˈʃɑːrpnər/',
    phoneticUK: '/ˈʃɑːpnə/',
    meaning: '卷笔刀',
    example: 'My pencil sharpener is blue.',
    exampleTranslation: '我的卷笔刀是蓝色的。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '✏️'
  },
  {
    id: 'elem-add-school-3',
    word: 'ruler',
    phoneticUS: '/ˈruːlər/',
    phoneticUK: '/ˈruːlə/',
    meaning: '尺子',
    example: 'I use a ruler to draw lines.',
    exampleTranslation: '我用尺子画线。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '📏'
  },
  {
    id: 'elem-add-school-4',
    word: 'notebook',
    phoneticUS: '/ˈnoʊtbʊk/',
    phoneticUK: '/ˈnəʊtbʊk/',
    meaning: '笔记本',
    example: 'I write in my notebook.',
    exampleTranslation: '我在笔记本上写字。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '📓'
  },
  {
    id: 'elem-add-school-5',
    word: 'textbook',
    phoneticUS: '/ˈtekstbʊk/',
    phoneticUK: '/ˈtekstbʊk/',
    meaning: '教科书',
    example: 'We use textbooks in class.',
    exampleTranslation: '我们在课堂上使用教科书。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '📖'
  },
  {
    id: 'elem-add-school-6',
    word: 'dictionary',
    phoneticUS: '/ˈdɪkʃəneri/',
    phoneticUK: '/ˈdɪkʃənri/',
    meaning: '字典',
    example: 'I look up words in the dictionary.',
    exampleTranslation: '我在字典里查单词。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '📚'
  },
  {
    id: 'elem-add-school-7',
    word: 'backpack',
    phoneticUS: '/ˈbækpæk/',
    phoneticUK: '/ˈbækpæk/',
    meaning: '书包',
    example: 'My backpack is heavy.',
    exampleTranslation: '我的书包很重。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🎒'
  },
  {
    id: 'elem-add-school-8',
    word: 'crayon',
    phoneticUS: '/ˈkreɪən/',
    phoneticUK: '/ˈkreɪən/',
    meaning: '蜡笔',
    example: 'I draw with crayons.',
    exampleTranslation: '我用蜡笔画画。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🖍️'
  },
  {
    id: 'elem-add-school-9',
    word: 'marker',
    phoneticUS: '/ˈmɑːrkər/',
    phoneticUK: '/ˈmɑːkə/',
    meaning: '马克笔',
    example: 'The teacher uses markers on the board.',
    exampleTranslation: '老师在黑板上使用马克笔。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🖊️'
  },
  {
    id: 'elem-add-school-10',
    word: 'scissors',
    phoneticUS: '/ˈsɪzərz/',
    phoneticUK: '/ˈsɪzəz/',
    meaning: '剪刀',
    example: 'Be careful with scissors.',
    exampleTranslation: '小心使用剪刀。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '✂️'
  },
  {
    id: 'elem-add-school-11',
    word: 'glue',
    phoneticUS: '/ɡluː/',
    phoneticUK: '/ɡluː/',
    meaning: '胶水',
    example: 'I use glue to stick paper.',
    exampleTranslation: '我用胶水粘纸。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧴'
  },
  {
    id: 'elem-add-school-12',
    word: 'tape',
    phoneticUS: '/teɪp/',
    phoneticUK: '/teɪp/',
    meaning: '胶带',
    example: 'I need some tape.',
    exampleTranslation: '我需要一些胶带。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '📦'
  },
  {
    id: 'elem-add-school-13',
    word: 'calculator',
    phoneticUS: '/ˈkælkjuleɪtər/',
    phoneticUK: '/ˈkælkjuleɪtə/',
    meaning: '计算器',
    example: 'We use calculators in math class.',
    exampleTranslation: '我们在数学课上使用计算器。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🔢'
  },
  {
    id: 'elem-add-school-14',
    word: 'blackboard',
    phoneticUS: '/ˈblækbɔːrd/',
    phoneticUK: '/ˈblækbɔːd/',
    meaning: '黑板',
    example: 'The teacher writes on the blackboard.',
    exampleTranslation: '老师在黑板上写字。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '⬛'
  },
  {
    id: 'elem-add-school-15',
    word: 'whiteboard',
    phoneticUS: '/ˈwaɪtbɔːrd/',
    phoneticUK: '/ˈwaɪtbɔːd/',
    meaning: '白板',
    example: 'Our classroom has a whiteboard.',
    exampleTranslation: '我们的教室有白板。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '⬜'
  },

  // 颜色补充（15词）
  {
    id: 'elem-add-color-1',
    word: 'pink',
    phoneticUS: '/pɪŋk/',
    phoneticUK: '/pɪŋk/',
    meaning: '粉色',
    example: 'Her dress is pink.',
    exampleTranslation: '她的裙子是粉色的。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🩷'
  },
  {
    id: 'elem-add-color-2',
    word: 'purple',
    phoneticUS: '/ˈpɜːrpl/',
    phoneticUK: '/ˈpɜːpl/',
    meaning: '紫色',
    example: 'I like purple flowers.',
    exampleTranslation: '我喜欢紫色的花。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '💜'
  },
  {
    id: 'elem-add-color-3',
    word: 'orange',
    phoneticUS: '/ˈɔːrɪndʒ/',
    phoneticUK: '/ˈɒrɪndʒ/',
    meaning: '橙色',
    example: 'The orange is orange.',
    exampleTranslation: '橙子是橙色的。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧡'
  },
  {
    id: 'elem-add-color-4',
    word: 'grey',
    phoneticUS: '/ɡreɪ/',
    phoneticUK: '/ɡreɪ/',
    meaning: '灰色',
    example: 'The sky is grey today.',
    exampleTranslation: '今天天空是灰色的。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🩶'
  },
  {
    id: 'elem-add-color-5',
    word: 'brown',
    phoneticUS: '/braʊn/',
    phoneticUK: '/braʊn/',
    meaning: '棕色',
    example: 'The bear is brown.',
    exampleTranslation: '熊是棕色的。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🤎'
  },
  {
    id: 'elem-add-color-6',
    word: 'gold',
    phoneticUS: '/ɡoʊld/',
    phoneticUK: '/ɡəʊld/',
    meaning: '金色',
    example: 'She has a gold medal.',
    exampleTranslation: '她有一枚金牌。',
    category: 'colors',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥇'
  },
  {
    id: 'elem-add-color-7',
    word: 'silver',
    phoneticUS: '/ˈsɪlvər/',
    phoneticUK: '/ˈsɪlvə/',
    meaning: '银色',
    example: 'He won a silver medal.',
    exampleTranslation: '他赢得了银牌。',
    category: 'colors',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥈'
  },
  {
    id: 'elem-add-color-8',
    word: 'beige',
    phoneticUS: '/beɪʒ/',
    phoneticUK: '/beɪʒ/',
    meaning: '米色',
    example: 'The wall is beige.',
    exampleTranslation: '墙壁是米色的。',
    category: 'colors',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🎨'
  },
  {
    id: 'elem-add-color-9',
    word: 'cream',
    phoneticUS: '/kriːm/',
    phoneticUK: '/kriːm/',
    meaning: '奶油色',
    example: 'She likes cream-colored clothes.',
    exampleTranslation: '她喜欢奶油色的衣服。',
    category: 'colors',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥛'
  },
  {
    id: 'elem-add-color-10',
    word: 'navy',
    phoneticUS: '/ˈneɪvi/',
    phoneticUK: '/ˈneɪvi/',
    meaning: '深蓝色',
    example: 'He wears a navy suit.',
    exampleTranslation: '他穿着深蓝色西装。',
    category: 'colors',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '👔'
  },
  {
    id: 'elem-add-color-11',
    word: 'light',
    phoneticUS: '/laɪt/',
    phoneticUK: '/laɪt/',
    meaning: '浅色的',
    example: 'I like light blue.',
    exampleTranslation: '我喜欢浅蓝色。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '💡'
  },
  {
    id: 'elem-add-color-12',
    word: 'dark',
    phoneticUS: '/dɑːrk/',
    phoneticUK: '/dɑːk/',
    meaning: '深色的',
    example: 'She has dark hair.',
    exampleTranslation: '她有深色的头发。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🌑'
  },
  {
    id: 'elem-add-color-13',
    word: 'bright',
    phoneticUS: '/braɪt/',
    phoneticUK: '/braɪt/',
    meaning: '鲜艳的',
    example: 'The sun is bright.',
    exampleTranslation: '阳光很明媚。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '☀️'
  },
  {
    id: 'elem-add-color-14',
    word: 'pale',
    phoneticUS: '/peɪl/',
    phoneticUK: '/peɪl/',
    meaning: '苍白的',
    example: 'She looks pale today.',
    exampleTranslation: '她今天看起来脸色苍白。',
    category: 'colors',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '👤'
  },
  {
    id: 'elem-add-color-15',
    word: 'colorful',
    phoneticUS: '/ˈkʌlərfl/',
    phoneticUK: '/ˈkʌləfl/',
    meaning: '多彩的',
    example: 'The rainbow is colorful.',
    exampleTranslation: '彩虹是多彩的。',
    category: 'colors',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🌈'
  },

  // ==================== 小学5-6年级补充（66词）====================

  // 日常生活补充（20词）
  {
    id: 'elem-add-daily-1',
    word: 'alarm clock',
    phoneticUS: '/əˈlɑːrm klɑːk/',
    phoneticUK: '/əˈlɑːm klɒk/',
    meaning: '闹钟',
    example: 'My alarm clock rings at 7 am.',
    exampleTranslation: '我的闹钟早上7点响。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '⏰'
  },
  {
    id: 'elem-add-daily-2',
    word: 'umbrella',
    phoneticUS: '/ʌmˈbrelə/',
    phoneticUK: '/ʌmˈbrelə/',
    meaning: '雨伞',
    example: 'Take an umbrella. It is raining.',
    exampleTranslation: '带把伞，下雨了。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '☂️'
  },
  {
    id: 'elem-add-daily-3',
    word: 'key',
    phoneticUS: '/kiː/',
    phoneticUK: '/kiː/',
    meaning: '钥匙',
    example: 'I lost my key.',
    exampleTranslation: '我弄丢了钥匙。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🔑'
  },
  {
    id: 'elem-add-daily-4',
    word: 'wallet',
    phoneticUS: '/ˈwɑːlɪt/',
    phoneticUK: '/ˈwɒlɪt/',
    meaning: '钱包',
    example: 'My wallet is in my bag.',
    exampleTranslation: '我的钱包在包里。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '👛'
  },
  {
    id: 'elem-add-daily-5',
    word: 'mirror',
    phoneticUS: '/ˈmɪrər/',
    phoneticUK: '/ˈmɪrə/',
    meaning: '镜子',
    example: 'Look in the mirror.',
    exampleTranslation: '照照镜子。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🪞'
  },
  {
    id: 'elem-add-daily-6',
    word: 'towel',
    phoneticUS: '/ˈtaʊəl/',
    phoneticUK: '/ˈtaʊəl/',
    meaning: '毛巾',
    example: 'I dry my face with a towel.',
    exampleTranslation: '我用毛巾擦干脸。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🧖'
  },
  {
    id: 'elem-add-daily-7',
    word: 'soap',
    phoneticUS: '/soʊp/',
    phoneticUK: '/səʊp/',
    meaning: '肥皂',
    example: 'Wash your hands with soap.',
    exampleTranslation: '用肥皂洗手。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🧼'
  },
  {
    id: 'elem-add-daily-8',
    word: 'shampoo',
    phoneticUS: '/ʃæmˈpuː/',
    phoneticUK: '/ʃæmˈpuː/',
    meaning: '洗发水',
    example: 'I need new shampoo.',
    exampleTranslation: '我需要新的洗发水。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🧴'
  },
  {
    id: 'elem-add-daily-9',
    word: 'toothbrush',
    phoneticUS: '/ˈtuːθbrʌʃ/',
    phoneticUK: '/ˈtuːθbrʌʃ/',
    meaning: '牙刷',
    example: 'Change your toothbrush every month.',
    exampleTranslation: '每个月更换牙刷。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🪥'
  },
  {
    id: 'elem-add-daily-10',
    word: 'toothpaste',
    phoneticUS: '/ˈtuːθpeɪst/',
    phoneticUK: '/ˈtuːθpeɪst/',
    meaning: '牙膏',
    example: 'Squeeze some toothpaste on the brush.',
    exampleTranslation: '挤一些牙膏在牙刷上。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🦷'
  },
  {
    id: 'elem-add-daily-11',
    word: 'comb',
    phoneticUS: '/koʊm/',
    phoneticUK: '/kəʊm/',
    meaning: '梳子',
    example: 'I comb my hair every morning.',
    exampleTranslation: '我每天早上梳头。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '💈'
  },
  {
    id: 'elem-add-daily-12',
    word: 'brush',
    phoneticUS: '/brʌʃ/',
    phoneticUK: '/brʌʃ/',
    meaning: '刷子',
    example: 'I brush my hair.',
    exampleTranslation: '我刷头发。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🪮'
  },
  {
    id: 'elem-add-daily-13',
    word: 'clock',
    phoneticUS: '/klɑːk/',
    phoneticUK: '/klɒk/',
    meaning: '时钟',
    example: 'The clock shows the time.',
    exampleTranslation: '时钟显示时间。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🕐'
  },
  {
    id: 'elem-add-daily-14',
    word: 'watch',
    phoneticUS: '/wɑːtʃ/',
    phoneticUK: '/wɒtʃ/',
    meaning: '手表',
    example: 'My watch is new.',
    exampleTranslation: '我的手表是新的。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '⌚'
  },
  {
    id: 'elem-add-daily-15',
    word: 'lamp',
    phoneticUS: '/læmp/',
    phoneticUK: '/læmp/',
    meaning: '台灯',
    example: 'Turn on the lamp.',
    exampleTranslation: '打开台灯。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '💡'
  },
  {
    id: 'elem-add-daily-16',
    word: 'fan',
    phoneticUS: '/fæn/',
    phoneticUK: '/fæn/',
    meaning: '风扇',
    example: 'The fan keeps us cool.',
    exampleTranslation: '风扇让我们保持凉爽。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🌀'
  },
  {
    id: 'elem-add-daily-17',
    word: 'camera',
    phoneticUS: '/ˈkæmərə/',
    phoneticUK: '/ˈkæmərə/',
    meaning: '相机',
    example: 'I take photos with my camera.',
    exampleTranslation: '我用相机拍照。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '📷'
  },
  {
    id: 'elem-add-daily-18',
    word: 'phone',
    phoneticUS: '/foʊn/',
    phoneticUK: '/fəʊn/',
    meaning: '电话',
    example: 'Answer the phone, please.',
    exampleTranslation: '请接电话。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '📞'
  },
  {
    id: 'elem-add-daily-19',
    word: 'battery',
    phoneticUS: '/ˈbætəri/',
    phoneticUK: '/ˈbætəri/',
    meaning: '电池',
    example: 'The battery is low.',
    exampleTranslation: '电池快没电了。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🔋'
  },
  {
    id: 'elem-add-daily-20',
    word: 'charger',
    phoneticUS: '/ˈtʃɑːrdʒər/',
    phoneticUK: '/ˈtʃɑːdʒə/',
    meaning: '充电器',
    example: 'I need my phone charger.',
    exampleTranslation: '我需要手机充电器。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🔌'
  },

  // 交通补充（16词）
  {
    id: 'elem-add-transport-1',
    word: 'bicycle',
    phoneticUS: '/ˈbaɪsɪkl/',
    phoneticUK: '/ˈbaɪsɪkl/',
    meaning: '自行车',
    example: 'I ride my bicycle to school.',
    exampleTranslation: '我骑自行车去学校。',
    category: 'transport',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🚲'
  },
  {
    id: 'elem-add-transport-2',
    word: 'bike',
    phoneticUS: '/baɪk/',
    phoneticUK: '/baɪk/',
    meaning: '自行车（口语）',
    example: 'My bike is red.',
    exampleTranslation: '我的自行车是红色的。',
    category: 'transport',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🚲'
  },
  {
    id: 'elem-add-transport-3',
    word: 'motorcycle',
    phoneticUS: '/ˈmoʊtərsaɪkl/',
    phoneticUK: '/ˈməʊtəsaɪkl/',
    meaning: '摩托车',
    example: 'He rides a motorcycle.',
    exampleTranslation: '他骑摩托车。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🏍️'
  },
  {
    id: 'elem-add-transport-4',
    word: 'subway',
    phoneticUS: '/ˈsʌbweɪ/',
    phoneticUK: '/ˈsʌbweɪ/',
    meaning: '地铁',
    example: 'I take the subway to work.',
    exampleTranslation: '我坐地铁上班。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚇'
  },
  {
    id: 'elem-add-transport-5',
    word: 'underground',
    phoneticUS: '/ˈʌndərɡraʊnd/',
    phoneticUK: '/ˈʌndəɡraʊnd/',
    meaning: '地铁（英式）',
    example: 'The underground is fast.',
    exampleTranslation: '地铁很快。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚇'
  },
  {
    id: 'elem-add-transport-6',
    word: 'ship',
    phoneticUS: '/ʃɪp/',
    phoneticUK: '/ʃɪp/',
    meaning: '轮船',
    example: 'The ship sails on the sea.',
    exampleTranslation: '轮船在海上航行。',
    category: 'transport',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🚢'
  },
  {
    id: 'elem-add-transport-7',
    word: 'boat',
    phoneticUS: '/boʊt/',
    phoneticUK: '/bəʊt/',
    meaning: '小船',
    example: 'We row the boat.',
    exampleTranslation: '我们划船。',
    category: 'transport',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '⛵'
  },
  {
    id: 'elem-add-transport-8',
    word: 'helicopter',
    phoneticUS: '/ˈhelɪkɑːptər/',
    phoneticUK: '/ˈhelɪkɒptə/',
    meaning: '直升机',
    example: 'The helicopter flies in the sky.',
    exampleTranslation: '直升机在天空中飞行。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚁'
  },
  {
    id: 'elem-add-transport-9',
    word: 'truck',
    phoneticUS: '/trʌk/',
    phoneticUK: '/trʌk/',
    meaning: '卡车',
    example: 'The truck carries goods.',
    exampleTranslation: '卡车运送货物。',
    category: 'transport',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🚚'
  },
  {
    id: 'elem-add-transport-10',
    word: 'taxi',
    phoneticUS: '/ˈtæksi/',
    phoneticUK: '/ˈtæksi/',
    meaning: '出租车',
    example: 'I called a taxi.',
    exampleTranslation: '我叫了一辆出租车。',
    category: 'transport',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🚕'
  },
  {
    id: 'elem-add-transport-11',
    word: 'van',
    phoneticUS: '/væn/',
    phoneticUK: '/væn/',
    meaning: '面包车',
    example: 'The van is white.',
    exampleTranslation: '面包车是白色的。',
    category: 'transport',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🚐'
  },
  {
    id: 'elem-add-transport-12',
    word: 'ambulance',
    phoneticUS: '/ˈæmbjələns/',
    phoneticUK: '/ˈæmbjələns/',
    meaning: '救护车',
    example: 'Call an ambulance!',
    exampleTranslation: '叫救护车！',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚑'
  },
  {
    id: 'elem-add-transport-13',
    word: 'fire truck',
    phoneticUS: '/ˈfaɪər trʌk/',
    phoneticUK: '/ˈfaɪə trʌk/',
    meaning: '消防车',
    example: 'The fire truck is red.',
    exampleTranslation: '消防车是红色的。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚒'
  },
  {
    id: 'elem-add-transport-14',
    word: 'police car',
    phoneticUS: '/pəˈliːs kɑːr/',
    phoneticUK: '/pəˈliːs kɑː/',
    meaning: '警车',
    example: 'The police car is coming.',
    exampleTranslation: '警车来了。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚔'
  },
  {
    id: 'elem-add-transport-15',
    word: 'traffic light',
    phoneticUS: '/ˈtræfɪk laɪt/',
    phoneticUK: '/ˈtræfɪk laɪt/',
    meaning: '红绿灯',
    example: 'Stop at the traffic light.',
    exampleTranslation: '在红绿灯处停下。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚦'
  },
  {
    id: 'elem-add-transport-16',
    word: 'parking lot',
    phoneticUS: '/ˈpɑːrkɪŋ lɑːt/',
    phoneticUK: '/ˈpɑːkɪŋ lɒt/',
    meaning: '停车场',
    example: 'The parking lot is full.',
    exampleTranslation: '停车场满了。',
    category: 'transport',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🅿️'
  },

  // 运动补充（15词）
  {
    id: 'elem-add-sport-1',
    word: 'tennis',
    phoneticUS: '/ˈtenɪs/',
    phoneticUK: '/ˈtenɪs/',
    meaning: '网球',
    example: 'I play tennis on weekends.',
    exampleTranslation: '我周末打网球。',
    category: 'sports',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🎾'
  },
  {
    id: 'elem-add-sport-2',
    word: 'volleyball',
    phoneticUS: '/ˈvɑːlibɔːl/',
    phoneticUK: '/ˈvɒlibɔːl/',
    meaning: '排球',
    example: 'We play volleyball on the beach.',
    exampleTranslation: '我们在沙滩上打排球。',
    category: 'sports',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🏐'
  },
  {
    id: 'elem-add-sport-3',
    word: 'baseball',
    phoneticUS: '/ˈbeɪsbɔːl/',
    phoneticUK: '/ˈbeɪsbɔːl/',
    meaning: '棒球',
    example: 'Baseball is popular in America.',
    exampleTranslation: '棒球在美国很受欢迎。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '⚾'
  },
  {
    id: 'elem-add-sport-4',
    word: 'golf',
    phoneticUS: '/ɡɑːlf/',
    phoneticUK: '/ɡɒlf/',
    meaning: '高尔夫',
    example: 'My dad plays golf.',
    exampleTranslation: '我爸爸打高尔夫。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '⛳'
  },
  {
    id: 'elem-add-sport-5',
    word: 'badminton',
    phoneticUS: '/ˈbædmɪntən/',
    phoneticUK: '/ˈbædmɪntən/',
    meaning: '羽毛球',
    example: 'I like playing badminton.',
    exampleTranslation: '我喜欢打羽毛球。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🏸'
  },
  {
    id: 'elem-add-sport-6',
    word: 'table tennis',
    phoneticUS: '/ˈteɪbl tenɪs/',
    phoneticUK: '/ˈteɪbl tenɪs/',
    meaning: '乒乓球',
    example: 'Table tennis is popular in China.',
    exampleTranslation: '乒乓球在中国很受欢迎。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🏓'
  },
  {
    id: 'elem-add-sport-7',
    word: 'skating',
    phoneticUS: '/ˈskeɪtɪŋ/',
    phoneticUK: '/ˈskeɪtɪŋ/',
    meaning: '滑冰',
    example: 'I go skating in winter.',
    exampleTranslation: '我冬天去滑冰。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '⛸️'
  },
  {
    id: 'elem-add-sport-8',
    word: 'skiing',
    phoneticUS: '/ˈskiːɪŋ/',
    phoneticUK: '/ˈskiːɪŋ/',
    meaning: '滑雪',
    example: 'Skiing is fun.',
    exampleTranslation: '滑雪很有趣。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🎿'
  },
  {
    id: 'elem-add-sport-9',
    word: 'climbing',
    phoneticUS: '/ˈklaɪmɪŋ/',
    phoneticUK: '/ˈklaɪmɪŋ/',
    meaning: '爬山',
    example: 'I enjoy climbing mountains.',
    exampleTranslation: '我喜欢爬山。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🧗'
  },
  {
    id: 'elem-add-sport-10',
    word: 'running',
    phoneticUS: '/ˈrʌnɪŋ/',
    phoneticUK: '/ˈrʌnɪŋ/',
    meaning: '跑步',
    example: 'Running is good for health.',
    exampleTranslation: '跑步对健康有益。',
    category: 'sports',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🏃'
  },
  {
    id: 'elem-add-sport-11',
    word: 'jumping',
    phoneticUS: '/ˈdʒʌmpɪŋ/',
    phoneticUK: '/ˈdʒʌmpɪŋ/',
    meaning: '跳跃',
    example: 'Jumping is fun.',
    exampleTranslation: '跳跃很有趣。',
    category: 'sports',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🦘'
  },
  {
    id: 'elem-add-sport-12',
    word: 'yoga',
    phoneticUS: '/ˈjoʊɡə/',
    phoneticUK: '/ˈjəʊɡə/',
    meaning: '瑜伽',
    example: 'My mom does yoga every day.',
    exampleTranslation: '我妈妈每天做瑜伽。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🧘'
  },
  {
    id: 'elem-add-sport-13',
    word: 'boxing',
    phoneticUS: '/ˈbɑːksɪŋ/',
    phoneticUK: '/ˈbɒksɪŋ/',
    meaning: '拳击',
    example: 'Boxing is a tough sport.',
    exampleTranslation: '拳击是一项艰难的运动。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🥊'
  },
  {
    id: 'elem-add-sport-14',
    word: 'karate',
    phoneticUS: '/kəˈrɑːti/',
    phoneticUK: '/kəˈrɑːti/',
    meaning: '空手道',
    example: 'I learn karate.',
    exampleTranslation: '我学空手道。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🥋'
  },
  {
    id: 'elem-add-sport-15',
    word: 'cycling',
    phoneticUS: '/ˈsaɪklɪŋ/',
    phoneticUK: '/ˈsaɪklɪŋ/',
    meaning: '骑自行车',
    example: 'Cycling is good exercise.',
    exampleTranslation: '骑自行车是很好的锻炼。',
    category: 'sports',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🚴'
  },

  // 天气补充（15词）
  {
    id: 'elem-add-weather-1',
    word: 'sunny',
    phoneticUS: '/ˈsʌni/',
    phoneticUK: '/ˈsʌni/',
    meaning: '晴朗的',
    example: 'Today is sunny.',
    exampleTranslation: '今天天气晴朗。',
    category: 'weather',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '☀️'
  },
  {
    id: 'elem-add-weather-2',
    word: 'cloudy',
    phoneticUS: '/ˈklaʊdi/',
    phoneticUK: '/ˈklaʊdi/',
    meaning: '多云的',
    example: 'It is cloudy today.',
    exampleTranslation: '今天多云。',
    category: 'weather',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '☁️'
  },
  {
    id: 'elem-add-weather-3',
    word: 'rainy',
    phoneticUS: '/ˈreɪni/',
    phoneticUK: '/ˈreɪni/',
    meaning: '下雨的',
    example: 'It is a rainy day.',
    exampleTranslation: '今天下雨。',
    category: 'weather',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🌧️'
  },
  {
    id: 'elem-add-weather-4',
    word: 'snowy',
    phoneticUS: '/ˈsnoʊi/',
    phoneticUK: '/ˈsnəʊi/',
    meaning: '下雪的',
    example: 'It is snowy in winter.',
    exampleTranslation: '冬天下雪。',
    category: 'weather',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '❄️'
  },
  {
    id: 'elem-add-weather-5',
    word: 'windy',
    phoneticUS: '/ˈwɪndi/',
    phoneticUK: '/ˈwɪndi/',
    meaning: '有风的',
    example: 'It is windy today.',
    exampleTranslation: '今天有风。',
    category: 'weather',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '💨'
  },
  {
    id: 'elem-add-weather-6',
    word: 'foggy',
    phoneticUS: '/ˈfɑːɡi/',
    phoneticUK: '/ˈfɒɡi/',
    meaning: '有雾的',
    example: 'It is foggy this morning.',
    exampleTranslation: '今天早上有雾。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🌫️'
  },
  {
    id: 'elem-add-weather-7',
    word: 'stormy',
    phoneticUS: '/ˈstɔːrmi/',
    phoneticUK: '/ˈstɔːmi/',
    meaning: '暴风雨的',
    example: 'It is stormy outside.',
    exampleTranslation: '外面有暴风雨。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '⛈️'
  },
  {
    id: 'elem-add-weather-8',
    word: 'thunder',
    phoneticUS: '/ˈθʌndər/',
    phoneticUK: '/ˈθʌndə/',
    meaning: '雷',
    example: 'I hear thunder.',
    exampleTranslation: '我听到雷声。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '⚡'
  },
  {
    id: 'elem-add-weather-9',
    word: 'lightning',
    phoneticUS: '/ˈlaɪtnɪŋ/',
    phoneticUK: '/ˈlaɪtnɪŋ/',
    meaning: '闪电',
    example: 'Lightning flashed in the sky.',
    exampleTranslation: '天空中闪电闪烁。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '⚡'
  },
  {
    id: 'elem-add-weather-10',
    word: 'rainbow',
    phoneticUS: '/ˈreɪnboʊ/',
    phoneticUK: '/ˈreɪnbəʊ/',
    meaning: '彩虹',
    example: 'I see a rainbow.',
    exampleTranslation: '我看到了彩虹。',
    category: 'weather',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    image: '🌈'
  },
  {
    id: 'elem-add-weather-11',
    word: 'temperature',
    phoneticUS: '/ˈtemprətʃər/',
    phoneticUK: '/ˈtemprətʃə/',
    meaning: '温度',
    example: 'The temperature is high today.',
    exampleTranslation: '今天的温度很高。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🌡️'
  },
  {
    id: 'elem-add-weather-12',
    word: 'degree',
    phoneticUS: '/dɪˈɡriː/',
    phoneticUK: '/dɪˈɡriː/',
    meaning: '度数',
    example: 'It is 30 degrees today.',
    exampleTranslation: '今天是30度。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🌡️'
  },
  {
    id: 'elem-add-weather-13',
    word: 'forecast',
    phoneticUS: '/ˈfɔːrkæst/',
    phoneticUK: '/ˈfɔːkɑːst/',
    meaning: '天气预报',
    example: 'The weather forecast says it will rain.',
    exampleTranslation: '天气预报说会下雨。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '📺'
  },
  {
    id: 'elem-add-weather-14',
    word: 'freeze',
    phoneticUS: '/friːz/',
    phoneticUK: '/friːz/',
    meaning: '结冰',
    example: 'The lake freezes in winter.',
    exampleTranslation: '冬天湖水结冰。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '🧊'
  },
  {
    id: 'elem-add-weather-15',
    word: 'melt',
    phoneticUS: '/melt/',
    phoneticUK: '/melt/',
    meaning: '融化',
    example: 'The snow melts in spring.',
    exampleTranslation: '春天雪融化了。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    image: '💧'
  },

  // ==================== 初中7-9年级补充（60词）====================

  // 科技类（20词）
  {
    id: 'mid-add-tech-1',
    word: 'computer',
    phoneticUS: '/kəmˈpjuːtər/',
    phoneticUK: '/kəmˈpjuːtə/',
    meaning: '电脑',
    example: 'I use a computer for work.',
    exampleTranslation: '我用电脑工作。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '💻'
  },
  {
    id: 'mid-add-tech-2',
    word: 'laptop',
    phoneticUS: '/ˈlæptɑːp/',
    phoneticUK: '/ˈlæptɒp/',
    meaning: '笔记本电脑',
    example: 'I carry my laptop to school.',
    exampleTranslation: '我带笔记本电脑去学校。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '💻'
  },
  {
    id: 'mid-add-tech-3',
    word: 'smartphone',
    phoneticUS: '/ˈsmɑːrtfoʊn/',
    phoneticUK: '/ˈsmɑːtfəʊn/',
    meaning: '智能手机',
    example: 'Everyone has a smartphone now.',
    exampleTranslation: '现在每个人都有智能手机。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '📱'
  },
  {
    id: 'mid-add-tech-4',
    word: 'tablet',
    phoneticUS: '/ˈtæblət/',
    phoneticUK: '/ˈtæblət/',
    meaning: '平板电脑',
    example: 'I read books on my tablet.',
    exampleTranslation: '我在平板电脑上读书。',
    category: 'technology',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '📲'
  },
  {
    id: 'mid-add-tech-5',
    word: 'keyboard',
    phoneticUS: '/ˈkiːbɔːrd/',
    phoneticUK: '/ˈkiːbɔːd/',
    meaning: '键盘',
    example: 'Type on the keyboard.',
    exampleTranslation: '在键盘上打字。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '⌨️'
  },
  {
    id: 'mid-add-tech-6',
    word: 'mouse',
    phoneticUS: '/maʊs/',
    phoneticUK: '/maʊs/',
    meaning: '鼠标',
    example: 'Click the mouse.',
    exampleTranslation: '点击鼠标。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🖱️'
  },
  {
    id: 'mid-add-tech-7',
    word: 'screen',
    phoneticUS: '/skriːn/',
    phoneticUK: '/skriːn/',
    meaning: '屏幕',
    example: 'Look at the screen.',
    exampleTranslation: '看屏幕。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🖥️'
  },
  {
    id: 'mid-add-tech-8',
    word: 'printer',
    phoneticUS: '/ˈprɪntər/',
    phoneticUK: '/ˈprɪntə/',
    meaning: '打印机',
    example: 'I need to use the printer.',
    exampleTranslation: '我需要使用打印机。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🖨️'
  },
  {
    id: 'mid-add-tech-9',
    word: 'internet',
    phoneticUS: '/ˈɪntərnet/',
    phoneticUK: '/ˈɪntənet/',
    meaning: '互联网',
    example: 'I search on the internet.',
    exampleTranslation: '我在互联网上搜索。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🌐'
  },
  {
    id: 'mid-add-tech-10',
    word: 'website',
    phoneticUS: '/ˈwebsaɪt/',
    phoneticUK: '/ˈwebsaɪt/',
    meaning: '网站',
    example: 'Visit our website.',
    exampleTranslation: '访问我们的网站。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🔗'
  },
  {
    id: 'mid-add-tech-11',
    word: 'email',
    phoneticUS: '/ˈiːmeɪl/',
    phoneticUK: '/ˈiːmeɪl/',
    meaning: '电子邮件',
    example: 'Send me an email.',
    exampleTranslation: '给我发一封电子邮件。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '📧'
  },
  {
    id: 'mid-add-tech-12',
    word: 'password',
    phoneticUS: '/ˈpæswɜːrd/',
    phoneticUK: '/ˈpɑːswɜːd/',
    meaning: '密码',
    example: 'Enter your password.',
    exampleTranslation: '输入你的密码。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🔐'
  },
  {
    id: 'mid-add-tech-13',
    word: 'username',
    phoneticUS: '/ˈjuːzərneɪm/',
    phoneticUK: '/ˈjuːzəneɪm/',
    meaning: '用户名',
    example: 'What is your username?',
    exampleTranslation: '你的用户名是什么？',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '👤'
  },
  {
    id: 'mid-add-tech-14',
    word: 'download',
    phoneticUS: '/ˈdaʊnloʊd/',
    phoneticUK: '/ˈdaʊnləʊd/',
    meaning: '下载',
    example: 'Download the app.',
    exampleTranslation: '下载这个应用。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '⬇️'
  },
  {
    id: 'mid-add-tech-15',
    word: 'upload',
    phoneticUS: '/ˈʌploʊd/',
    phoneticUK: '/ˈʌpləʊd/',
    meaning: '上传',
    example: 'Upload your photo.',
    exampleTranslation: '上传你的照片。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '⬆️'
  },
  {
    id: 'mid-add-tech-16',
    word: 'software',
    phoneticUS: '/ˈsɔːftwer/',
    phoneticUK: '/ˈsɒftweə/',
    meaning: '软件',
    example: 'Install the software.',
    exampleTranslation: '安装软件。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '💿'
  },
  {
    id: 'mid-add-tech-17',
    word: 'hardware',
    phoneticUS: '/ˈhɑːrdwer/',
    phoneticUK: '/ˈhɑːdweə/',
    meaning: '硬件',
    example: 'Computer hardware is expensive.',
    exampleTranslation: '电脑硬件很贵。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🔧'
  },
  {
    id: 'mid-add-tech-18',
    word: 'robot',
    phoneticUS: '/ˈroʊbɑːt/',
    phoneticUK: '/ˈrəʊbɒt/',
    meaning: '机器人',
    example: 'Robots can do many things.',
    exampleTranslation: '机器人能做很多事情。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🤖'
  },
  {
    id: 'mid-add-tech-19',
    word: 'Wi-Fi',
    phoneticUS: '/ˈwaɪ faɪ/',
    phoneticUK: '/ˈwaɪ faɪ/',
    meaning: '无线网络',
    example: 'Connect to Wi-Fi.',
    exampleTranslation: '连接无线网络。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '📶'
  },
  {
    id: 'mid-add-tech-20',
    word: 'Bluetooth',
    phoneticUS: '/ˈbluːtuːθ/',
    phoneticUK: '/ˈbluːtuːθ/',
    meaning: '蓝牙',
    example: 'Turn on Bluetooth.',
    exampleTranslation: '打开蓝牙。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🔵'
  },

  // 职业类补充（20词）
  {
    id: 'mid-add-job-1',
    word: 'actor',
    phoneticUS: '/ˈæktər/',
    phoneticUK: '/ˈæktə/',
    meaning: '演员',
    example: 'He is a famous actor.',
    exampleTranslation: '他是一位著名的演员。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🎭'
  },
  {
    id: 'mid-add-job-2',
    word: 'actress',
    phoneticUS: '/ˈæktrəs/',
    phoneticUK: '/ˈæktrəs/',
    meaning: '女演员',
    example: 'She is a great actress.',
    exampleTranslation: '她是一位伟大的女演员。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🎭'
  },
  {
    id: 'mid-add-job-3',
    word: 'singer',
    phoneticUS: '/ˈsɪŋər/',
    phoneticUK: '/ˈsɪŋə/',
    meaning: '歌手',
    example: 'She is a popular singer.',
    exampleTranslation: '她是一位受欢迎的歌手。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🎤'
  },
  {
    id: 'mid-add-job-4',
    word: 'dancer',
    phoneticUS: '/ˈdænsər/',
    phoneticUK: '/ˈdɑːnsə/',
    meaning: '舞者',
    example: 'She is a professional dancer.',
    exampleTranslation: '她是一位专业舞者。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '💃'
  },
  {
    id: 'mid-add-job-5',
    word: 'artist',
    phoneticUS: '/ˈɑːrtɪst/',
    phoneticUK: '/ˈɑːtɪst/',
    meaning: '艺术家',
    example: 'He is a talented artist.',
    exampleTranslation: '他是一位有才华的艺术家。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🎨'
  },
  {
    id: 'mid-add-job-6',
    word: 'writer',
    phoneticUS: '/ˈraɪtər/',
    phoneticUK: '/ˈraɪtə/',
    meaning: '作家',
    example: 'She is a famous writer.',
    exampleTranslation: '她是一位著名的作家。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '✍️'
  },
  {
    id: 'mid-add-job-7',
    word: 'musician',
    phoneticUS: '/mjuːˈzɪʃn/',
    phoneticUK: '/mjuːˈzɪʃn/',
    meaning: '音乐家',
    example: 'He is a great musician.',
    exampleTranslation: '他是一位伟大的音乐家。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🎵'
  },
  {
    id: 'mid-add-job-8',
    word: 'scientist',
    phoneticUS: '/ˈsaɪəntɪst/',
    phoneticUK: '/ˈsaɪəntɪst/',
    meaning: '科学家',
    example: 'Scientists discover new things.',
    exampleTranslation: '科学家发现新事物。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🔬'
  },
  {
    id: 'mid-add-job-9',
    word: 'engineer',
    phoneticUS: '/ˌendʒɪˈnɪr/',
    phoneticUK: '/ˌendʒɪˈnɪə/',
    meaning: '工程师',
    example: 'My uncle is an engineer.',
    exampleTranslation: '我叔叔是工程师。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '👷'
  },
  {
    id: 'mid-add-job-10',
    word: 'pilot',
    phoneticUS: '/ˈpaɪlət/',
    phoneticUK: '/ˈpaɪlət/',
    meaning: '飞行员',
    example: 'He wants to be a pilot.',
    exampleTranslation: '他想当飞行员。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '✈️'
  },
  {
    id: 'mid-add-job-11',
    word: 'lawyer',
    phoneticUS: '/ˈlɔːjər/',
    phoneticUK: '/ˈlɔːjə/',
    meaning: '律师',
    example: 'She is a successful lawyer.',
    exampleTranslation: '她是一位成功的律师。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '⚖️'
  },
  {
    id: 'mid-add-job-12',
    word: 'journalist',
    phoneticUS: '/ˈdʒɜːrnəlɪst/',
    phoneticUK: '/ˈdʒɜːnəlɪst/',
    meaning: '记者',
    example: 'She works as a journalist.',
    exampleTranslation: '她是一名记者。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '📰'
  },
  {
    id: 'mid-add-job-13',
    word: 'chef',
    phoneticUS: '/ʃef/',
    phoneticUK: '/ʃef/',
    meaning: '厨师',
    example: 'He is a famous chef.',
    exampleTranslation: '他是一位著名的厨师。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '👨‍🍳'
  },
  {
    id: 'mid-add-job-14',
    word: 'waiter',
    phoneticUS: '/ˈweɪtər/',
    phoneticUK: '/ˈweɪtə/',
    meaning: '服务员（男）',
    example: 'The waiter brought the menu.',
    exampleTranslation: '服务员拿来了菜单。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🧑‍🍳'
  },
  {
    id: 'mid-add-job-15',
    word: 'waitress',
    phoneticUS: '/ˈweɪtrəs/',
    phoneticUK: '/ˈweɪtrəs/',
    meaning: '服务员（女）',
    example: 'The waitress is friendly.',
    exampleTranslation: '女服务员很友好。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '👩‍🍳'
  },
  {
    id: 'mid-add-job-16',
    word: 'soldier',
    phoneticUS: '/ˈsoʊldʒər/',
    phoneticUK: '/ˈsəʊldʒə/',
    meaning: '士兵',
    example: 'He is a brave soldier.',
    exampleTranslation: '他是一位勇敢的士兵。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🎖️'
  },
  {
    id: 'mid-add-job-17',
    word: 'athlete',
    phoneticUS: '/ˈæθliːt/',
    phoneticUK: '/ˈæθliːt/',
    meaning: '运动员',
    example: 'She is a professional athlete.',
    exampleTranslation: '她是一名专业运动员。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🏃'
  },
  {
    id: 'mid-add-job-18',
    word: 'coach',
    phoneticUS: '/koʊtʃ/',
    phoneticUK: '/kəʊtʃ/',
    meaning: '教练',
    example: 'Our coach is strict but kind.',
    exampleTranslation: '我们的教练严格但和蔼。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🧑‍🏫'
  },
  {
    id: 'mid-add-job-19',
    word: 'president',
    phoneticUS: '/ˈprezɪdənt/',
    phoneticUK: '/ˈprezɪdənt/',
    meaning: '总统',
    example: 'The president gave a speech.',
    exampleTranslation: '总统发表了演讲。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '👔'
  },
  {
    id: 'mid-add-job-20',
    word: 'manager',
    phoneticUS: '/ˈmænɪdʒər/',
    phoneticUK: '/ˈmænɪdʒə/',
    meaning: '经理',
    example: 'He is the manager of the company.',
    exampleTranslation: '他是公司的经理。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '💼'
  },

  // 自然环境类补充（20词）
  {
    id: 'mid-add-nature-1',
    word: 'ocean',
    phoneticUS: '/ˈoʊʃn/',
    phoneticUK: '/ˈəʊʃn/',
    meaning: '海洋',
    example: 'The ocean is very deep.',
    exampleTranslation: '海洋非常深。',
    category: 'nature',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '🌊'
  },
  {
    id: 'mid-add-nature-2',
    word: 'sea',
    phoneticUS: '/siː/',
    phoneticUK: '/siː/',
    meaning: '海',
    example: 'The sea is blue.',
    exampleTranslation: '大海是蓝色的。',
    category: 'nature',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🌊'
  },
  {
    id: 'mid-add-nature-3',
    word: 'river',
    phoneticUS: '/ˈrɪvər/',
    phoneticUK: '/ˈrɪvə/',
    meaning: '河流',
    example: 'The river flows to the sea.',
    exampleTranslation: '河流流向大海。',
    category: 'nature',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🏞️'
  },
  {
    id: 'mid-add-nature-4',
    word: 'lake',
    phoneticUS: '/leɪk/',
    phoneticUK: '/leɪk/',
    meaning: '湖',
    example: 'We swim in the lake.',
    exampleTranslation: '我们在湖里游泳。',
    category: 'nature',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🏞️'
  },
  {
    id: 'mid-add-nature-5',
    word: 'island',
    phoneticUS: '/ˈaɪlənd/',
    phoneticUK: '/ˈaɪlənd/',
    meaning: '岛屿',
    example: 'We visited an island.',
    exampleTranslation: '我们参观了一个岛屿。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🏝️'
  },
  {
    id: 'mid-add-nature-6',
    word: 'desert',
    phoneticUS: '/ˈdezərt/',
    phoneticUK: '/ˈdezət/',
    meaning: '沙漠',
    example: 'The desert is very hot.',
    exampleTranslation: '沙漠非常热。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🏜️'
  },
  {
    id: 'mid-add-nature-7',
    word: 'volcano',
    phoneticUS: '/vɑːlˈkeɪnoʊ/',
    phoneticUK: '/vɒlˈkeɪnəʊ/',
    meaning: '火山',
    example: 'The volcano erupted.',
    exampleTranslation: '火山爆发了。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🌋'
  },
  {
    id: 'mid-add-nature-8',
    word: 'earthquake',
    phoneticUS: '/ˈɜːrθkweɪk/',
    phoneticUK: '/ˈɜːθkweɪk/',
    meaning: '地震',
    example: 'The earthquake was strong.',
    exampleTranslation: '地震很强烈。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🌏'
  },
  {
    id: 'mid-add-nature-9',
    word: 'planet',
    phoneticUS: '/ˈplænɪt/',
    phoneticUK: '/ˈplænɪt/',
    meaning: '行星',
    example: 'Earth is a planet.',
    exampleTranslation: '地球是一颗行星。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🪐'
  },
  {
    id: 'mid-add-nature-10',
    word: 'star',
    phoneticUS: '/stɑːr/',
    phoneticUK: '/stɑː/',
    meaning: '星星',
    example: 'The stars are bright tonight.',
    exampleTranslation: '今晚星星很亮。',
    category: 'nature',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '⭐'
  },
  {
    id: 'mid-add-nature-11',
    word: 'moon',
    phoneticUS: '/muːn/',
    phoneticUK: '/muːn/',
    meaning: '月亮',
    example: 'The moon is full tonight.',
    exampleTranslation: '今晚月圆。',
    category: 'nature',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🌙'
  },
  {
    id: 'mid-add-nature-12',
    word: 'sky',
    phoneticUS: '/skaɪ/',
    phoneticUK: '/skaɪ/',
    meaning: '天空',
    example: 'Look at the blue sky.',
    exampleTranslation: '看那蓝蓝的天空。',
    category: 'nature',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🌌'
  },
  {
    id: 'mid-add-nature-13',
    word: 'universe',
    phoneticUS: '/ˈjuːnɪvɜːrs/',
    phoneticUK: '/ˈjuːnɪvɜːs/',
    meaning: '宇宙',
    example: 'The universe is huge.',
    exampleTranslation: '宇宙很大。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🌌'
  },
  {
    id: 'mid-add-nature-14',
    word: 'space',
    phoneticUS: '/speɪs/',
    phoneticUK: '/speɪs/',
    meaning: '太空',
    example: 'Astronauts travel in space.',
    exampleTranslation: '宇航员在太空中旅行。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🚀'
  },
  {
    id: 'mid-add-nature-15',
    word: 'environment',
    phoneticUS: '/ɪnˈvaɪrənmənt/',
    phoneticUK: '/ɪnˈvaɪrənmənt/',
    meaning: '环境',
    example: 'We must protect the environment.',
    exampleTranslation: '我们必须保护环境。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🌍'
  },
  {
    id: 'mid-add-nature-16',
    word: 'pollution',
    phoneticUS: '/pəˈluːʃn/',
    phoneticUK: '/pəˈluːʃn/',
    meaning: '污染',
    example: 'Air pollution is a big problem.',
    exampleTranslation: '空气污染是个大问题。',
    category: 'nature',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '🏭'
  },
  {
    id: 'mid-add-nature-17',
    word: 'recycle',
    phoneticUS: '/riːˈsaɪkl/',
    phoneticUK: /riːˈsaɪkl/,
    meaning: '回收利用',
    example: 'We should recycle paper.',
    exampleTranslation: '我们应该回收纸张。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '♻️'
  },
  {
    id: 'mid-add-nature-18',
    word: 'energy',
    phoneticUS: '/ˈenərdʒi/',
    phoneticUK: '/ˈenədʒi/',
    meaning: '能源',
    example: 'Solar energy is clean.',
    exampleTranslation: '太阳能是清洁能源。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '⚡'
  },
  {
    id: 'mid-add-nature-19',
    word: 'electricity',
    phoneticUS: '/ɪˌlekˈtrɪsəti/',
    phoneticUK: '/ɪˌlekˈtrɪsəti/',
    meaning: '电',
    example: 'We use electricity every day.',
    exampleTranslation: '我们每天都用电。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '💡'
  },
  {
    id: 'mid-add-nature-20',
    word: 'resource',
    phoneticUS: '/ˈriːsɔːrs/',
    phoneticUK: '/rɪˈsɔːs/',
    meaning: '资源',
    example: 'Natural resources are limited.',
    exampleTranslation: '自然资源是有限的。',
    category: 'nature',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '🏭'
  }
];
